module.exports = __webpack_public_path__ + "img/sb01-04.09f39660.png";